import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React from "react";

interface DeleteJobDialogProps {
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
  jobTitle: string;
  handleRemoveJob: () => void;
}

const DeleteJobDialog = ({
  isVisible,
  setIsVisible,
  jobTitle,
  handleRemoveJob,
}: DeleteJobDialogProps) => {
  return (
    <Dialog
      header="Delete Job"
      visible={isVisible}
      onHide={() => setIsVisible(false)}
      style={{ minWidth: "16vw" }}
    >
      <p>Are you sure you want to delete job {jobTitle}?</p>
      <div className="flex justify-content-end gap-2">
        <Button
          label="Cancel"
          icon="pi pi-times"
          className="p-button-text"
          onClick={() => setIsVisible(false)}
        />
        <Button
          label="Delete"
          icon="pi pi-check"
          className="p-button-text"
          onClick={handleRemoveJob}
        />
      </div>
    </Dialog>
  );
};

export default DeleteJobDialog;
